var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-input',_vm._b({attrs:{"label":_vm.label,"validation-errors":_vm.validationErrors,"placeholder":"Enter time e.g. 3h 20m"},on:{"blur":_vm.handleInput},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},'form-field-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }